export default __webpack_public_path__ + "locales/vi/EmptyTrashDialog.json?hash=c5270078b215d6d79a963f12fbf80889";